export default __webpack_public_path__ + "static/media/slide.1c6d86cc.mp3";